module.exports = __webpack_public_path__ + "img/f-03.224fba0b.jpg";